<section class="home">

  <!-- =====================================================
       HERO SLIDER
       ===================================================== -->

  <section class="hero">

    <div
      class="hero-slide"
      *ngFor="let slide of slides(); let i = index"
      [class.active]="i === currentSlide()"
    >
      <img
        [src]="getCategoryImage(slide)"
        
        class="hero-image"
      />

      <div class="hero-overlay"></div>

      <div class="hero-content">

       <button
  type="button"
  class="hero-button"
  (click)="shopNow()"
>
  <span>{{ 'HOME.SHOP_NOW' | translate }}</span>

<mat-icon
>
  arrow_forward
</mat-icon>
</button>

      </div>

    </div>


    <!-- PREVIOUS -->

    <button
      type="button"
      class="slider-arrow slider-prev"
      (click)="previousSlide()"
      aria-label="Previous slide"
    >

      <mat-icon>
        chevron_left
      </mat-icon>

    </button>


    <!-- NEXT -->

    <button
      type="button"
      class="slider-arrow slider-next"
      (click)="nextSlide()"
      aria-label="Next slide"
    >

      <mat-icon>
        chevron_right
      </mat-icon>

    </button>


    <!-- DOTS -->

    <div class="slider-dots">

      <button
        type="button"
        *ngFor="let slide of slides(); let i = index"
        [class.active]="i === currentSlide()"
        (click)="goToSlide(i)"
        aria-label="Go to slide"
      >
      </button>

    </div>

  </section>



  <!-- =====================================================
       CATEGORIES
       ===================================================== -->

  <section class="categories-section scroll-reveal">
<app-categories></app-categories>

  </section>


<!-- =====================================================
     BRANDS
     ===================================================== -->

<section class="brands-section scroll-reveal">

  
<app-brands></app-brands>

 <div class="seeMore">
<h3 (click)="headToAllBrands()">{{'COMMON.seeMore'| translate}}</h3>
 </div>


  <!-- BRAND CAROUSEL -->

 

</section>
 <!-- =====================================================
       BEST SELLERS
       ===================================================== -->

  <section class="best-sellers-section scroll-reveal">

    <app-best-sellers
    [addedToCartProductId]="addedToCartProductId()"
    [alreadyInCartProductId]="alreadyInCartProductId()"

    (productClicked)="openProductDetails($event)"
    (addToCartClicked)="addToCart($event)">
  </app-best-sellers>

  </section>

   <section class="best-sellers-section scroll-reveal">

    <app-new-arrival-products
    [addedToCartProductId]="addedToCartProductId()"
    [alreadyInCartProductId]="alreadyInCartProductId()"

    (productClicked)="openProductDetails($event)"
    (addToCartClicked)="addToCart($event)">
  </app-new-arrival-products>

  </section>
</section>